import logo from "../assets/logo10years.png";

const Footer = () => {
  return (
    <>
      <style>{`
        /* Prefix 'ft-' for Footer isolation */
        .ft-footer {
          /* Locked at exactly 20px top and bottom */
          padding: 20px 0; 
          background-color: #0b1120; /* Matching the Founders/Problem dark theme */
          border-top: 1px solid rgba(255, 255, 255, 0.08);
          width: 100%;
          box-sizing: border-box;
        }

        .ft-container {
          /* Full width allowed */
          max-width: 100%; 
          margin: 0 auto;
          padding: 0 2rem;
          text-align: center;
        }

        .ft-logo {
          height: 1.5rem;
          margin: 0 auto 0.5rem auto; /* Centered logo with small gap below */
          display: block;
        }

        .ft-disclaimer {
          font-size: 0.75rem;
          color: #94a3b8;
          margin: 0;
          /* Force text onto a single line */
          white-space: nowrap; 
          /* Allow it to span the full width of the container */
          width: 100%;
          letter-spacing: 0.01em;
        }

        /* Mobile responsiveness: ensures the single line doesn't overflow */
        @media (max-width: 1024px) {
          .ft-disclaimer {
            font-size: 0.7rem;
          }
        }

        @media (max-width: 768px) {
          .ft-disclaimer {
            font-size: 0.6rem;
          }
          .ft-logo {
            height: 1.25rem;
          }
        }

        @media (max-width: 480px) {
          .ft-disclaimer {
            font-size: 0.5rem; /* Shrunk for very small screens to maintain 1 line */
          }
        }
      `}</style>

      <footer className="ft-footer">
        <div className="ft-container">
          <img src={logo} alt="The Startup Zone" className="ft-logo" />
          <p className="ft-disclaimer">
            Educational content only. Not legal advice. Always consult a qualified CA or counsel.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;